<template>
  <v-app class="app">
    <v-overlay :value="$store.state.loadPage.show" class="text-center" :opacity="0.7" z-index="1000">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
      <p>{{$store.state.loadPage.message}}</p>
    </v-overlay>


    <v-app-bar class="bgAppBar" app height="64"  dark>
      <v-btn icon @click="drawer = !drawer" dark :disabled="($route.name == 'Unauthorized' || $route.name == 'Authenticate')">
        <v-icon large color="secondary">mdi-menu</v-icon>
      </v-btn>
      <Header :drawer="drawer"></Header>
    </v-app-bar>
    
    <v-navigation-drawer v-model="drawer" v-if="drawer" app  class="navigation-custom ">
      <Navigation></Navigation>
    </v-navigation-drawer>

    <v-main class="bgMain">
      <v-container fluid class="pa-6">
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-snackbar
      vertical
      v-model="$store.state.snackbar.show"
      :color="$store.state.snackbar.color"
      top
      text
      outlined
      shaped
      elevation="24">
        <div class="d-flex justify-center text-center">{{ $store.state.snackbar.text }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn :color="$store.state.snackbar.color" text v-bind="attrs" @click="$store.state.snackbar.show = false"> Cerrar
          </v-btn>
        </template>
    </v-snackbar>
    
    <v-footer app>

    </v-footer>
  </v-app>
</template>

<script>

import Header from "./views/app/Header.vue";
import Navigation from "./views/app/Navigation.vue";
import eventBus from "./event-bus.js"
export default {
  name: 'App',

  components: {
    Header,
    Navigation,
  },
  data: () => ({
    drawer: true,
    loadPage : { show: false, message: 'Cargando...' }
  }),
  created(){
    const data = {
                    show: false,
                    message:"",
                    color: "",
                }

    this.$store.state.snackbar = data
  },
  beforeMount(){
    this.$store.state.loadPage.show = false
  },
  mounted(){
    let vm = this;
    eventBus.$on("loadPage", function (data) {
      vm.$store.state.loadPage = data;
    });
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    currentRouteName() {
      return this.$route.name;
    },
    urlAdminYomob(){
      let url = (window.location.href.includes('localhost')) ? 'http://localhost:4200' : 
                  (window.location.href.includes('dev-')) ? 'https://dev-yomob-admin.uxshows.com' : 'https://yomob-admin.uxshows.com'
      return url + '/usuarios/form/' + this.$store.state.user.Usu_Id
    }
  },
  watch:{
    '$route.name'(val){
      if(val == 'Unauthorized' || val == 'Authenticate') this.drawer = false
      else this.drawer = true
    }
  }
};
</script>

<style>
  
  .navigation-custom {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;
  }

 .bgMain{
  background-color:#8df5f50a; 
 }

  /* width */
  ::-webkit-scrollbar {
    width: .9rem !important;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f2f3f8 !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #B2B2B2 !important;
    border-radius: 10px !important;
  }

  .bgAppBar{
      background-image: url('~@/assets/bgAppBar.png'); 
      background-size: cover; 
  }

  
</style>
